module.exports = __webpack_public_path__ + "img/profile.66547974.svg";